import gql from 'graphql-tag'

export const CREATE_UPDATE_ORDER_ORDER_ITEMS = gql`
    mutation ($orderObj:[Orders_insert_input!]!, $orders_on_conflict_rule: Orders_on_conflict!) {
        insert_Orders(objects: $orderObj, on_conflict: $orders_on_conflict_rule){
            returning{
                id
            }
        }
    }`
export const CREATE_UPDATE_ORGANIZATION_STOCK = gql`
    mutation ($updateFromOrgStock:[OrganizationStock_insert_input!]!,$updateToOrgStock:[OrganizationStock_insert_input!]!, $organizationStock_on_conflict_rule: OrganizationStock_on_conflict!) {
        FromOrg:insert_OrganizationStock(objects: $updateFromOrgStock, on_conflict: $organizationStock_on_conflict_rule){
            returning{
                id
            }
        },
        ToOrg:insert_OrganizationStock(objects: $updateToOrgStock, on_conflict: $organizationStock_on_conflict_rule){
            returning{
                id
            }
        }
    }`

export const ADD_SALES_ORDER = gql`
mutation addSalesOrder($order:[Orders_insert_input!]!, $orderItems:[OrderItems_insert_input!]!, 
            $orgStock:[OrganizationStock_insert_input!]!, $updateColumnsOrgStock: [OrganizationStock_update_column!]!) {
  insert_Orders(objects: $order){
   affected_rows
  }
  insert_OrderItems(objects: $orderItems){
   affected_rows
  } 
  insert_OrganizationStock(objects: $orgStock, on_conflict: {constraint: OrganizationStock_pkey, update_columns: $updateColumnsOrgStock}){
    returning{id}
  }
}`